/*追忆*/
export const RECOLLECTION =    (process.env.NODE_ENV === 'production')? 29 : 58;
/*追思*/
export const REMINISCENCE =   (process.env.NODE_ENV === 'production')? 30 : 58;     //30
/*追寻*/
export const MOSTSOUGHT  =  (process.env.NODE_ENV === 'production')? 31 : 58;      //31
/*铭记历史 致敬胜利*/
export const REMEMBER  =    (process.env.NODE_ENV === 'production')? 33 : 58;   //33
/*总书记讲故事*/
export const TELLASTORY =   (process.env.NODE_ENV === 'production')? 26 : 58;  //26

export const urlpostfix = (process.env.NODE_ENV === 'production')? "web-api/":"";

export const jsonpostfix = (process.env.NODE_ENV === 'production')? "JSON/":"";



// WEBPACK FOOTER //
// ./src/config/global.js